export function getItem(key) {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error("Local storage (getItem) is not supported", error);
    return null;
  }
}

export function setItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error("Local storage (setItem) is not supported", error);
  }
}

function parseFrontmatterDate(date) {
  return new Date(date.replace(' UTC', '').replace(' ', 'T'));
}

function parseGitDate(date) {
  return new Date(date.slice(0, -6).replace(' ', 'T'));
}

/**
 * Git last-modified can predate a manually set publish date in frontmatter.
 * Ensure the displayed "Last updated" time is never earlier than "Published".
 */
export function resolveUpdatedAt(gitUpdatedAt, publishedAt) {
  if (!gitUpdatedAt) {
    return { date: '', isGitDate: false };
  }

  if (!publishedAt) {
    return { date: gitUpdatedAt, isGitDate: true };
  }

  const gitTime = parseGitDate(gitUpdatedAt).getTime();
  const publishedTime = parseFrontmatterDate(publishedAt).getTime();

  if (Number.isNaN(gitTime)) {
    return { date: gitUpdatedAt, isGitDate: true };
  }

  if (Number.isNaN(publishedTime) || gitTime >= publishedTime) {
    return { date: gitUpdatedAt, isGitDate: true };
  }

  return { date: publishedAt, isGitDate: false };
}
